<template>
    <section class="footer">
        <div class="footer_con">
            <div>
                <h2>联系我们</h2>
                <span></span>
                <span>公司名称：厦门鸿宁兴科技有限公司</span>
                <span>联系人：商务部-杨经理</span>
                <span>联系电话：180 1765 0737</span>
                <span>公司地址：厦门市翔安区金海街道洞庭路7号 华论南商A座 19楼1901单元</span>
            </div>
            <img src="../assets/ditu.png" />
        </div>
        <div class="footer_di">Copyright © 2009-2023 厦门鸿宁兴科技有限公司 版权所有 闽ICP备2021010477号-1</div>
    </section>
</template>
  
<script>
export default {
    name: "Footer",
    data() {
        return {
        }
    },
    methods: {
    },
}
</script>
  
<style lang="scss" scoped>
.footer {
    // position: absolute;
    // bottom: 0;
    height: 26.625rem;
    background: #F9F9F9;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    padding: 0 7.5rem;

    .footer_con {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        &>div {
            flex-flow: column;
            display: flex;
            line-height: 3.125rem;

            &>h2 {
                font-size: 1.875rem;
                font-weight: 400;
                color: #333333;
            }

            &>span:nth-child(2) {
                width: 6.25rem;
                height: 1px;
                background: #E0E0E0;
                margin-top: 1remx;
            }

            &>span {
                font-size: 1rem;
                font-weight: 400;
                color: #808080;
            }
        }

        &>img {
            width: 29rem;
            height: 14.8125rem;
        }
    }

    .footer_di {
        font-size: .875rem;
        font-weight: 400;
        color: #808080;
        text-align: center;
        margin-top: 3.125rem;
    }
}
</style>
  